// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavBar_nav__1PPpU","logo":"NavBar_logo__o5ybU"};